import React from 'react'

const caretRight = () => {
	return (
		<svg className='caret-right-icon' width='18' height='32' viewBox='0 -1 9 16'>
			<polyline
				stroke='#000'
				fill='none'
				strokeMiterlimit='10'
				points='1.6,1.2 6.5,7.9 1.6,14.7'
			/>
		</svg>
	)
}

export default caretRight
